import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Base64 } from 'js-base64';
import './LoginPage.css';
import axios from 'axios';
import Cookies from 'js-cookie';

function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const history = useHistory();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://renobuilding.ca/wp-json/reno/v1/rb_person_login', {
        username: username,
        password: password,
      }, {
        headers: {
          'Authorization': 'Basic ' + Base64.encode('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO')
        }
      });
      // Save account info in cookies
      Cookies.set('accountInfo', response.data[0]);
      // Redirect to receipt page after successful login
      history.push('/receipt');
    } catch (error) {
      console.error('Login failed:', error);
      // Handle login failure
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleLogin}>
        <h2>Login</h2>
        <div className="form-group">
          <label htmlFor="username">Username</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Login</button>
      </form>
    </div>
  );
}

export default LoginPage;
